<template>
  <el-form status-icon :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="120px"
    class="carpo-form demo-ruleForm md:grid flex flex-col">
    <el-form-item :label="$t('MOBILE')" prop="mobile">
      <el-input :disabled="ruleForm.disabled" type="text" v-model="ruleForm.mobile" autocomplete="off"
        @input="ruleForm.mobile = toEnglish(ruleForm.mobile)" class="left-inputs"></el-input>
    </el-form-item>
    <el-form-item prop="email" :label="$t('EMAIL')">
      <el-input :disabled="ruleForm.disabled" v-model="ruleForm.email"></el-input>
    </el-form-item>
    <div class="hidden lg:flex lg:col-span-1 xl:col-span-2"></div>

    <el-form-item :label="$t('PROVINCE')" prop="address.province.id">
      <el-select :disabled="ruleForm.disabled" :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.address.province.id" filterable clearable
        @change="provinceChange(ruleForm.address.province.id)">
        <el-option v-for="item in provinceList" :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-loading="cityLoading" element-loading-spinner="el-icon-loading" :label="$t('CITY')"
      prop="address.city.id">
      <el-select :placeholder="$t('SELECT_PLACEHOLDER')" v-model="ruleForm.address.city.id" filterable clearable
        @change="cityChange(ruleForm.address.city.id)"
        :disabled="ruleForm.address.province.id === '' || ruleForm.disabled">
        <el-option v-for="item in cityList" :key="item.id" :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-loading="neighborhoodLoading" element-loading-spinner="el-icon-loading" :label="$t('NEIGHBORHOOD')"
      prop="address.neighborhood.id">
      <el-select :placeholder="$t('SELECT_PLACEHOLDER')" v-model="ruleForm.address.neighborhood.id"
        @change="neighborhoodChange()" filterable clearable
        :disabled="ruleForm.address.city.id === '' || ruleForm.disabled">
        <el-option v-for="item in neighborhoodList" :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('POSTAL_CODE')" prop="address.postal_code">
      <el-input :disabled="ruleForm.disabled" type="text" @input="
        ruleForm.address.postal_code = toEnglish(ruleForm.address.postal_code)
      " v-model="ruleForm.address.postal_code" autocomplete="off" class="left-inputs"></el-input>
    </el-form-item>

    <el-form-item class="lg:col-span-2 xl:col-span-full" prop="address.postal_address" :label="$t('ADDRESS')" :rules="[
      {
        required: true,
        message: $t('REQUIRED_FIELD', { type: $t('ADDRESS') }),
        trigger: 'blur',
      },
    ]">
      <el-input :disabled="ruleForm.disabled" v-model="ruleForm.address.postal_address"></el-input>
    </el-form-item>

    <el-form-item class="flex justify-end col-span-full mt-4">
      <slot> </slot>
      <el-button type="success" @click="submitForm('ruleForm')">
        {{ $t("NEXT_FORM") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { provinceList, cityList, neighborhoodList } from "@/api/global";
export default {
  props: ["ruleForm", "loading"],
  data() {
    var checkMobile = (rule, value, callback) => {
      var strongRegex = new RegExp("^(\\+98|0)?9[\u06F0-\u06F90-9]{9}$");
      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", { type: this.$i18n.t("MOBILE") })
          )
        );
      }
    };
    var checkpostalcode = (rule, value, callback) => {
      var strongRegex = new RegExp("^[\u06F0-\u06F90-9]{10}$");
      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", { type: this.$i18n.t("POSTAL_CODE") })
          )
        );
      }
    };
    var checkSelect = (rule, value, callback) => {
      if (value != "") {
        callback();
      } else {
        callback(new Error(rule.message));
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (value == "") {
        callback();
      }
      if (value != undefined) {
        var strongRegex = new RegExp(
          "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"
        );
        if (strongRegex.test(value)) {
          callback();
        } else {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", { type: this.$i18n.t("EMAIL") })
            )
          );
        }
      } else {
        callback();
      }
    };
    return {
      date: "",
      countryList: [],
      cityList: [],
      neighborhoodList: [],
      provinceList: [],
      cityLoading: false,
      neighborhoodLoading: false,
      addressId: "",
      rules: {
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: checkMobile,
          },
        ],
        address: {
          postal_code: [
            {
              required: true,
              trigger: "blur",
              validator: checkpostalcode,
            },
          ],
          neighborhood: {
            id: [
              {
                required: true,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("NEIGHBORHOOD"),
                }),
              },
            ],
          },
          city: {
            id: [
              {
                required: true,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("CITY"),
                }),
              },
            ],
          },
          province: {
            id: [
              {
                required: true,
                validator: checkSelect,
                trigger: "change",
                message: this.$i18n.t("REQUIRED_CHOOSE", {
                  type: this.$i18n.t("PROVINCE"),
                }),
              },
            ],
          },
        },

        email: [
          {
            required: false,
            trigger: "blur",
            validator: checkEmail,
          },
        ],
      },
    };
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$refs[form].clearValidate();
          this.$emit("next", true);
          this.$emit("ruleForm", this.ruleForm);
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: "error_msg",
          });
          return false;
        }
      });
    },
    provinceChange(el) {
      this.ruleForm.address.city.id = "";
      this.ruleForm.address.neighborhood.id = "";
      this.cityLoading = true;
      if (el) {
        cityList.api(el).then((res) => {
          if (res) {
            this.cityList = res;
            this.cityLoading = false;
          }
        });
      }
    },
    cityChange(el) {
      this.ruleForm.address.neighborhood.id = "";
      this.neighborhoodLoading = true;
      if (el) {
        neighborhoodList.api(el).then((res) => {
          if (res) {
            this.neighborhoodList = res;
            this.neighborhoodLoading = false;
          }
        });
      }
    },
    neighborhoodChange() {
      return;
    },
  },
  mounted() {
    provinceList.api().then((res) => {
      if (res) {
        this.provinceList = res;
      }
    });
    if (this.ruleForm.address.city.id != "") {
      this.cityLoading = true;
      this.neighborhoodLoading = true;
      cityList.api(this.ruleForm.address.province.id).then((res) => {
        if (res) {
          this.cityList = res;
          this.cityLoading = false;
        }
      });
      neighborhoodList.api(this.ruleForm.address.city.id).then((res) => {
        if (res) {
          this.neighborhoodList = res;
          this.neighborhoodLoading = false;
        }
      });
    }
  },
};
</script>
